module.exports = __webpack_public_path__ + "img/deposit.3e47ac34.png";